export type SceneCategory = "sample" | "indoor" | "outdoor" | "venue";

export interface ScenePreset {
  id: string;
  label: string;
  url: string;
  category: SceneCategory;
  description?: string;
  source?: string;
}

export const SCENE_PRESETS: ScenePreset[] = [
  {
    id: "hornedlizard",
    label: "Horned Lizard",
    url: "/scenes/hornedlizard.spz",
    category: "sample",
    description: "BabylonJS reference splat — high-detail object capture, great for stress tests",
    source: "assets.babylonjs.com",
  },
  {
    id: "kitchen",
    label: "Kitchen",
    url: "/scenes/kitchen.spz",
    category: "indoor",
    description: "Mip-NeRF 360 indoor scene, 7k Inria-3DGS",
    source: "dylanebert/3dgs (HF)",
  },
  {
    id: "bonsai",
    label: "Bonsai (room)",
    url: "/scenes/bonsai.spz",
    category: "indoor",
    description: "Mip-NeRF 360 indoor room with a bonsai centerpiece, 7k 3DGS",
    source: "dylanebert/3dgs (HF)",
  },
  {
    id: "counter",
    label: "Kitchen counter",
    url: "/scenes/counter.spz",
    category: "indoor",
    description: "Mip-NeRF 360 close-up kitchen counter, 7k 3DGS",
    source: "dylanebert/3dgs (HF)",
  },
  {
    id: "van_gogh",
    label: "Van Gogh Museum (ours)",
    url: "/scenes/van_gogh.spz",
    category: "venue",
    description: "Our own iPhone capture, gsplat MCMC + 3DGUT + antialias + bilateral grid + app_optim",
    source: "this project",
  },
];

export function defaultSceneUrl(): string {
  const fromQuery = new URLSearchParams(window.location.search).get("scene");
  if (fromQuery) return fromQuery;
  // Default to van_gogh if it exists (will 404 gracefully until baked), else first sample
  return SCENE_PRESETS[0]!.url;
}
